module.exports = __webpack_public_path__ + "img/Img-login-1.5589319e.png";